import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import Masonry from '../../external/masonry'

class Extension {
    constructor() {
        this.isInit = false;
        this.sliderBeforeAfterInstance = null;
        this.picturesMasonry = null;
    }

    init() {
        if (!this.isInit) {
            this.sliderBeforeAfter = document.getElementById('sliderBeforeAfter');
            this.sliderSwitchers = document.querySelectorAll('[data-swiper-switcher]');
            this.picturesPreviewBox = document.getElementById('picturesPreviewBox');

            this.onHandlerSliderSwitcherClick = this.handlerSliderSwitcherClick.bind(this);

            this.isInit = true;
            this.bind();
        }
    }

    destroy() {
        if (this.isInit) {
            this.isInit = false;
            this.unbind();
        }
    }

    bind() {
        if (this.sliderBeforeAfter) {
            this.sliderBeforeAfterInstance = new Swiper(this.sliderBeforeAfter, {
                allowTouchMove: false
            });

            this.sliderSwitchers.forEach(el => {
                el.addEventListener('click', this.onHandlerSliderSwitcherClick);
            });
        }

        if (this.picturesPreviewBox) {
            const promises = [];
            this.picturesPreviewBox.querySelectorAll('div').forEach(div => {
                promises.push(
                    new Promise((resolve, reject) => {
                        const img = new Image();
                        img.onload = () => resolve(img);
                        img.onerror = reject;
                        img.src = div.dataset.img;
                        div.append(img);
                    })
                );
            });

            Promise.all(promises).then(() => {
                this.picturesPreviewBox.classList.remove('wait-img');
                this.picturesMasonry = new Masonry(this.picturesPreviewBox, {
                    itemSelector: 'div',
                    gutter: 20,
                    columnWidth: 280
                });
            }).catch(e => {
                console.error('Images load from Masonry - ERROR!', e || null);
            })
        }
    }

    unbind() {
        if (this.sliderBeforeAfter) {
            this.sliderBeforeAfterInstance.destroy();
            this.sliderBeforeAfterInstance = null;

            this.sliderSwitchers.forEach(el => {
                el.removeEventListener('click', this.onHandlerSliderSwitcherClick);
            });
        }

        if (this.picturesMasonry) {
            this.picturesMasonry.destroy();
            this.picturesMasonry = null;
        }
    }

    handlerSliderSwitcherClick(e) {
        e.preventDefault();
        this.sliderSwitchers.forEach(el => {
            if (el === e.target) {
                el.classList.add('active');
            } else {
                el.classList.remove('active');
            }
        });
        this.sliderBeforeAfterInstance.slideTo(Number(e.target.dataset.swiperSwitcher), 300, true);
    }
}

export default Extension;